import {
  defineAnalysisReviewRules,
  type DefineRule,
  type RuleConditions,
} from "./ability-rule-conditions";

export const defineAdminRules = (
  can: DefineRule,
  cannot: DefineRule,
  conditions: RuleConditions,
) => {
  can("manage", "all");
  cannot("startAnalysis", "Task");
  cannot("markSectionReviewed", "Case");
  can("markSectionReviewed", "Case", conditions.assignedAnalysisReview);
  cannot(["createReminder", "updateReminder", "removeReminder"], "Task");
  can(["createReminder", "updateReminder", "removeReminder"], "Task", conditions.assignedTask);
};

export const defineManagerRules = (can: DefineRule, conditions: RuleConditions) => {
  can(
    [
      "create",
      "read",
      "update",
      "delete",
      "changeStep",
      "transitionToLegalProcess",
      "analyze",
      "finishOthersDraft",
      "manageNotes",
      "manageOtherNotes",
      "manageConversations",
      "deleteContacts",
      "viewHistory",
    ],
    "Case",
  );
  defineAnalysisReviewRules(can, conditions);
  can(["createReminder", "updateReminder", "removeReminder"], "Task", conditions.assignedTask);
  can("overrideReviewedAnalysis", "Case");
  can("manage", "Client");
  can(
    [
      "create",
      "createPrimary",
      "cancel",
      "reopen",
      "read",
      "readAll",
      "update",
      "assignOnCreate",
      "updateMetadata",
      "manageDeadline",
      "waiveRequirements",
      "bypassTaskOwnership",
      "emailAssignee",
    ],
    "Task",
  );
  can("execute", "Task", conditions.assignedTask);
  can(["create", "update", "delete"], "Document");
  can(["read", "readAnalysis"], "Document", { visibleTo: "Manager" });
  can(["read", "update"], "Profile");
  can("read", "Dashboard");
  can("read", "Calendar");
  can("read", "Report");
  can("read", "Financial");
  can(["create", "read", "update", "broadcast"], "Notification");
  can(["read", "update"], "UserPreferences");
  can("read", "Automation");
};
